module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou10-79b008217add7d27842bdbf31f954d40.jpg";